(() => {
  "use strict";

  const SECTION_SELECTOR =
    "[data-digi-club-savings-calculator]";

  const instances = new WeakMap();

  class DigiClubSavingsCalculator {
    constructor(section) {
      this.section = section;

      this.dataElement = this.section.querySelector(
        "[data-digi-club-savings-data]"
      );

      this.productButtons = Array.from(
        this.section.querySelectorAll(
          "[data-digi-club-savings-product-option]"
        )
      );

      this.periodButtons = Array.from(
        this.section.querySelectorAll(
          "[data-digi-club-savings-period-option]"
        )
      );

      this.selectedProductElement =
        this.section.querySelector(
          "[data-digi-club-savings-selected-product]"
        );

      this.selectedPeriodElement =
        this.section.querySelector(
          "[data-digi-club-savings-selected-period]"
        );

      this.regularPriceElement =
        this.section.querySelector(
          "[data-digi-club-savings-regular-price]"
        );

      this.subscriptionPriceElement =
        this.section.querySelector(
          "[data-digi-club-savings-subscription-price]"
        );

      this.savingsPerDeliveryElement =
        this.section.querySelector(
          "[data-digi-club-savings-per-delivery]"
        );

      this.annualSavingsElement =
        this.section.querySelector(
          "[data-digi-club-savings-annual]"
        );

      this.annualResultElement =
        this.section.querySelector(
          "[data-digi-club-savings-annual-result]"
        );

      this.summaryMediaElement =
        this.section.querySelector(
          "[data-digi-club-savings-summary-media]"
        );

      this.summaryImageElement =
        this.section.querySelector(
          "[data-digi-club-savings-summary-image]"
        ) ||
        this.summaryMediaElement?.querySelector(
          ".digi-club-savings-calculator__summary-image"
        );

      this.ctaElement =
        this.section.querySelector(
          "[data-digi-club-modal-trigger]"
        );

      this.revealElements = Array.from(
        this.section.querySelectorAll(
          "[data-digi-club-savings-reveal]"
        )
      );

      this.data = null;
      this.products = [];
      this.periods = [];

this.selectedProduct = null;
this.selectedPeriod = null;
this.productQuantities = new Map();

      this.currency = "BRL";
      this.locale = "pt-BR";

      this.moneyFormatter = null;
      this.revealObserver = null;

      this.handleProductClick =
        this.handleProductClick.bind(this);

      this.handlePeriodClick =
        this.handlePeriodClick.bind(this);

      this.init();
    }

    init() {
      if (!this.dataElement) {
        return;
      }

      this.data = this.parseData();

      if (!this.data) {
        return;
      }

      this.products = Array.isArray(
        this.data.products
      )
        ? this.data.products
        : [];

      this.periods = Array.isArray(
        this.data.periods
      )
        ? this.data.periods
        : [];

      this.currency =
        this.data.currency || "BRL";

      this.locale =
        this.data.locale || "pt-BR";

      this.moneyFormatter =
        this.createMoneyFormatter();

      this.prepareProductButtons();
      this.bindEvents();
      this.setInitialSelection();
      this.setupReveal();
    }

    parseData() {
      try {
        return JSON.parse(
          this.dataElement.textContent.trim()
        );
      } catch (error) {
        console.error(
          "[Digi Club Savings Calculator] JSON inválido.",
          error
        );

        return null;
      }
    }

    createMoneyFormatter() {
      try {
        return new Intl.NumberFormat(
          this.locale,
          {
            style: "currency",
            currency: this.currency
          }
        );
      } catch (error) {
        console.warn(
          "[Digi Club Savings Calculator] Não foi possível usar a moeda informada. BRL será utilizada.",
          error
        );

        this.currency = "BRL";

        return new Intl.NumberFormat(
          "pt-BR",
          {
            style: "currency",
            currency: "BRL"
          }
        );
      }
    }

    prepareProductButtons() {
      this.productButtons.forEach((button) => {
        const product =
          this.getProductByBlockId(
            button.dataset.productBlockId
          );

        if (!product) {
          return;
        }

        const available =
          product.available !== false;

        button.classList.toggle(
          "is-unavailable",
          !available
        );

        button.setAttribute(
          "aria-disabled",
          String(!available)
        );

        /*
         * Não usamos button.disabled aqui porque o Theme Editor
         * precisa continuar permitindo a seleção do bloco.
         *
         * A indisponibilidade é controlada no evento de clique.
         */
      });
    }

    bindEvents() {
      this.productButtons.forEach((button) => {
        button.addEventListener(
          "click",
          this.handleProductClick
        );
      });

      this.productButtons.forEach((button) => {

        const plus =
          button.querySelector(
            "[data-digi-club-quantity-plus]"
          );

        const minus =
          button.querySelector(
            "[data-digi-club-quantity-minus]"
          );

        if (plus) {

          plus.addEventListener(
            "click",
            (event) => {

              event.preventDefault();
              event.stopPropagation();

              this.incrementProduct(button);

            }
          );

        }

        if (minus) {

          minus.addEventListener(
            "click",
            (event) => {

              event.preventDefault();
              event.stopPropagation();

              this.decrementProduct(button);

            }
          );

        }

      });

      this.periodButtons.forEach((button) => {
        button.addEventListener(
          "click",
          this.handlePeriodClick
        );
      });
    }

    unbindEvents() {
      this.productButtons.forEach((button) => {
        button.removeEventListener(
          "click",
          this.handleProductClick
        );
      });

      this.periodButtons.forEach((button) => {
        button.removeEventListener(
          "click",
          this.handlePeriodClick
        );
      });
    }

    setInitialSelection() {
      const activeProductButton =
        this.productButtons.find((button) =>
          button.classList.contains(
            "is-active"
          )
        );

      const activePeriodButton =
        this.periodButtons.find((button) =>
          button.classList.contains(
            "is-active"
          )
        );

      let initialProduct =
        this.getProductByBlockId(
          activeProductButton?.dataset
            .productBlockId
        );

      const initialPeriod =
        this.getPeriodByBlockId(
          activePeriodButton?.dataset
            .periodBlockId
        ) ||
        this.periods[0] ||
        null;

      /*
       * Caso o primeiro produto resolvido pelo Liquid esteja
       * indisponível, priorizamos o primeiro produto disponível.
       */
      if (
        !initialProduct ||
        initialProduct.available === false
      ) {
        initialProduct =
          this.products.find(
            (product) =>
              product.available !== false
          ) ||
          initialProduct ||
          this.products[0] ||
          null;
      }

      this.selectedProduct =
        null;

      this.selectedPeriod =
        initialPeriod;

      this.updateCalculator();
    }

    handleProductClick(event) {
      const button =
        event.currentTarget;

      const product =
        this.getProductByBlockId(
          button.dataset.productBlockId
        );

      if (
        !product ||
        product.available === false
      ) {
        event.preventDefault();
        return;
      }

      this.selectProduct(product);
    }

    handlePeriodClick(event) {
      const button =
        event.currentTarget;

      const period =
        this.getPeriodByBlockId(
          button.dataset.periodBlockId
        );

      if (!period) {
        return;
      }

      this.selectPeriod(period);
    }

    incrementProduct(button) {

      const product =
        this.getProductByBlockId(
          button.dataset.productBlockId
        );

      if (!product) {
        return;
      }

      const productId =
        String(product.productId);

      const quantity =
        this.productQuantities.get(productId) || 0;

      this.productQuantities.set(
        productId,
        quantity + 1
      );

      this.updateProductQuantity(button);
      this.updateCalculator();

    }

    decrementProduct(button) {

      const product =
        this.getProductByBlockId(
          button.dataset.productBlockId
        );

      if (!product) {
        return;
      }

      const productId =
        String(product.productId);

      const quantity =
        this.productQuantities.get(productId) || 0;

      if (quantity <= 0) {
        return;
      }

      this.productQuantities.set(
        productId,
        quantity - 1
      );

      this.updateProductQuantity(button);
      this.updateCalculator();

    }

    updateProductQuantity(button) {

      const product =
        this.getProductByBlockId(
          button.dataset.productBlockId
        );

      if (!product) {
        return;
      }

      const quantity =
        this.productQuantities.get(
          String(product.productId)
        ) || 0;

      const element =
        button.querySelector(
          "[data-digi-club-quantity]"
        );

      if (element) {
        element.textContent = quantity;
      }

    }

    selectProduct(product) {
      if (!product) {
        return;
      }

      if (product.available === false) {
        return;
      }

      this.selectedProduct = product;

      this.updateProductSelection();
      this.updateCalculator();
    }

    selectPeriod(period) {
      if (!period) {
        return;
      }

      this.selectedPeriod = period;

      this.updatePeriodSelection();
      this.updateCalculator();
    }

    selectBlock(blockId) {
      if (!blockId) {
        return;
      }

      const product =
        this.getProductByBlockId(
          blockId
        );

      if (product) {
        /*
         * No Theme Editor permitimos visualizar o produto
         * mesmo se ele estiver indisponível.
         */
        this.selectedProduct = product;

        this.updateProductSelection();
        this.updateCalculator();

        return;
      }

      const period =
        this.getPeriodByBlockId(
          blockId
        );

      if (period) {
        this.selectedPeriod = period;

        this.updatePeriodSelection();
        this.updateCalculator();
      }
    }

    updateProductSelection() {
      this.productButtons.forEach((button) => {
        const isActive =
          button.dataset.productBlockId ===
          String(
            this.selectedProduct?.blockId ||
            ""
          );

        button.classList.toggle(
          "is-active",
          isActive
        );

        button.setAttribute(
          "aria-pressed",
          String(isActive)
        );
      });
    }

    updatePeriodSelection() {
      this.periodButtons.forEach((button) => {
        const isActive =
          button.dataset.periodBlockId ===
          String(
            this.selectedPeriod?.blockId ||
            ""
          );

        button.classList.toggle(
          "is-active",
          isActive
        );

        button.setAttribute(
          "aria-pressed",
          String(isActive)
        );
      });
    }

    updateCalculator() {
      if (!this.selectedPeriod) {

        this.updateCtaState(false);

        return;
      }

      let regularPrice = 0;

      const averageShipping =
      this.toInteger(
        this.data.settings
          ?.averageShipping ?? 1500
      );

      this.products.forEach((product) => {

        const quantity =
          this.productQuantities.get(
            String(product.productId)
          ) || 0;

        if (quantity <= 0) {
          return;
        }

        regularPrice +=
          this.toInteger(
            product.regularPrice
          ) * quantity;

      });

      const hasSelectedProducts =
        regularPrice > 0;

      if (regularPrice <= 0) {

        this.updateSelectionSummary();

        this.setText(
          this.regularPriceElement,
          this.formatMoney(0)
        );

        this.setText(
          this.subscriptionPriceElement,
          this.formatMoney(0)
        );

        this.setText(
          this.savingsPerDeliveryElement,
          this.formatMoney(0)
        );

        this.updateAnnualSavings(
          0,
          0
        );

        this.updateCtaState(false);
        return;

      }

      const discountPercent =
        this.clamp(
          this.toNumber(
            this.selectedPeriod.discountPercent
          ),
          0,
          100
        );

      const annualDeliveries =
        Math.max(
          0,
          this.toNumber(
            this.selectedPeriod.annualDeliveries
          )
        );

      const regularPriceWithShipping =
        regularPrice + averageShipping;

      const productDiscount =
        Math.round(
          regularPrice *
          discountPercent /
          100
        );

      const subscriptionPrice =
        Math.max(
          regularPrice -
          productDiscount,
          0
        );


      const savingsPerDelivery =
        Math.max(
          regularPriceWithShipping -
          subscriptionPrice,
          0
        );

      const annualSavings =
        Math.round(
          savingsPerDelivery *
          annualDeliveries
        );

      this.updateSelectionSummary();

      this.setText(
        this.regularPriceElement,
        this.formatMoney(
          regularPriceWithShipping
        )
      );

      this.setText(
        this.subscriptionPriceElement,
        this.formatMoney(
          subscriptionPrice
        )
      );

      this.setText(
        this.savingsPerDeliveryElement,
        this.formatMoney(
          savingsPerDelivery
        )
      );

      this.updateAnnualSavings(
        annualSavings,
        annualDeliveries
      );

      this.updateCta();
    }

    updateSelectionSummary() {

      const selectedProducts = [];

      this.products.forEach((product) => {

        const quantity =
          this.productQuantities.get(
            String(product.productId)
          ) || 0;

        if (quantity <= 0) {
          return;
        }

        selectedProducts.push(
          `${quantity}x ${product.productTitle}`
        );

      });

      if (selectedProducts.length === 0) {

        this.setText(
          this.selectedProductElement,
          ""
        );

        this.setText(
          this.selectedPeriodElement,
          ""
        );

        return;

      }

      this.setText(
        this.selectedProductElement,
        selectedProducts.join("\n")
      );

      this.setText(
        this.selectedPeriodElement,
        this.selectedPeriod?.name || ""
      );

    }

    updateSummaryImage() {
      if (
        !this.summaryMediaElement ||
        !this.summaryImageElement
      ) {
        return;
      }

      const firstProduct =
        this.products.find((product) => {

          const quantity =
            this.productQuantities.get(
              String(product.productId)
            ) || 0;

          return quantity > 0;

        });

      if (!firstProduct) {

        this.summaryMediaElement.classList.add(
          "is-hidden"
        );

        return;

      }

      const imageUrl =
        firstProduct.image || "";

      const imageAlt =
        firstProduct.imageAlt ||
        firstProduct.productTitle ||
        "";

      if (!imageUrl) {
        this.summaryMediaElement.classList.add(
          "is-hidden"
        );

        this.summaryImageElement.removeAttribute(
          "src"
        );

        this.summaryImageElement.alt = "";

        return;
      }

      this.summaryImageElement.src =
        imageUrl;

      this.summaryImageElement.alt =
        imageAlt;

      /*
       * O srcset criado inicialmente pelo Liquid poderia manter
       * as imagens do primeiro produto. Ele é removido para que
       * a troca utilize corretamente o novo src.
       */
      this.summaryImageElement.removeAttribute(
        "srcset"
      );

      this.summaryImageElement.removeAttribute(
        "sizes"
      );

      this.summaryMediaElement.classList.remove(
        "is-hidden"
      );
    }

    updateAnnualSavings(
      annualSavings,
      annualDeliveries
    ) {
      if (
        !this.annualResultElement ||
        !this.annualSavingsElement
      ) {
        return;
      }

      const showAnnualSavings =
        this.data.settings
          ?.showAnnualSavings !== false &&
        annualDeliveries > 0;

      this.annualResultElement.classList.toggle(
        "is-hidden",
        !showAnnualSavings
      );

      if (!showAnnualSavings) {
        return;
      }

      this.setText(
        this.annualSavingsElement,
        this.formatMoney(
          annualSavings
        )
      );
    }

    updateCta() {

      if (!this.ctaElement) {
        return;
      }

      const period =
        this.selectedPeriod;

      if (!period) {
        this.updateCtaState(false);
        return;
      }

      const selectedProducts = [];

      this.products.forEach((product) => {

        const quantity =
          this.productQuantities.get(
            String(product.productId)
          ) || 0;

        if (quantity <= 0) {
          return;
        }

        selectedProducts.push({

          productId:
            product.productId,

          productHandle:
            product.productHandle,

          variantId:
            product.variantId,

          variantTitle:
            product.variantTitle,

          productTitle:
            product.productTitle,

          productBlockId:
            product.blockId,

          quantity

        });

      });

      if (!selectedProducts.length) {

        this.updateCtaState(false);

        delete this.ctaElement.dataset.products;

        return;

      }

      this.ctaElement.dataset.products =
        JSON.stringify(
          selectedProducts
        );

      this.setDataAttribute(
        this.ctaElement,
        "periodBlockId",
        period.blockId
      );

      this.setDataAttribute(
        this.ctaElement,
        "periodKey",
        period.key
      );

      this.setDataAttribute(
        this.ctaElement,
        "periodName",
        period.name
      );

      this.setDataAttribute(
        this.ctaElement,
        "periodDurationValue",
        period.durationValue
      );

      this.setDataAttribute(
        this.ctaElement,
        "periodDurationUnit",
        period.durationUnit
      );

      this.setDataAttribute(
        this.ctaElement,
        "periodDiscount",
        period.discountPercent
      );

      this.setDataAttribute(
        this.ctaElement,
        "periodAnnualDeliveries",
        period.annualDeliveries
      );

      this.updateCtaState(true);

    }

    updateCtaState(enabled) {
      if (!this.ctaElement) {
        return;
      }

      this.ctaElement.setAttribute(
        "aria-disabled",
        String(!enabled)
      );

      /*
       * O disabled nativo impede que outro listener global
       * do modal abra a assinatura de um produto indisponível.
       */
      this.ctaElement.disabled =
        !enabled;
    }

    getProductByBlockId(blockId) {
      if (!blockId) {
        return null;
      }

      return (
        this.products.find(
          (product) =>
            String(product.blockId) ===
            String(blockId)
        ) ||
        null
      );
    }

    getPeriodByBlockId(blockId) {
      if (!blockId) {
        return null;
      }

      return (
        this.periods.find(
          (period) =>
            String(period.blockId) ===
            String(blockId)
        ) ||
        null
      );
    }

    setDataAttribute(
      element,
      property,
      value
    ) {
      if (!element) {
        return;
      }

      if (
        value === null ||
        value === undefined ||
        value === ""
      ) {
        delete element.dataset[property];
        return;
      }

      element.dataset[property] =
        String(value);
    }

    setText(element, value) {
      if (!element) {
        return;
      }

      element.textContent =
        value ?? "";
    }

    formatMoney(cents) {
      const normalizedCents =
        this.toInteger(cents);

      return this.moneyFormatter.format(
        normalizedCents / 100
      );
    }

    toInteger(value) {
      const number =
        Number(value);

      if (!Number.isFinite(number)) {
        return 0;
      }

      return Math.round(number);
    }

    toNumber(value) {
      const number =
        Number(value);

      if (!Number.isFinite(number)) {
        return 0;
      }

      return number;
    }

    clamp(value, minimum, maximum) {
      return Math.min(
        Math.max(value, minimum),
        maximum
      );
    }

    setupReveal() {
      if (!this.revealElements.length) {
        return;
      }

      const reducedMotion =
        window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;

      if (
        reducedMotion ||
        !("IntersectionObserver" in window)
      ) {
        this.showAllRevealElements();
        return;
      }

      this.revealObserver =
        new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                return;
              }

              entry.target.classList.add(
                "is-visible"
              );

              observer.unobserve(
                entry.target
              );
            });
          },
          {
            threshold: 0.14,
            rootMargin:
              "0px 0px -8% 0px"
          }
        );

      this.revealElements.forEach(
        (element) => {
          this.revealObserver.observe(
            element
          );
        }
      );
    }

    showAllRevealElements() {
      this.revealElements.forEach(
        (element) => {
          element.classList.add(
            "is-visible"
          );
        }
      );
    }

    destroy() {
      this.unbindEvents();

      if (this.revealObserver) {
        this.revealObserver.disconnect();
        this.revealObserver = null;
      }

      this.section = null;
      this.dataElement = null;

      this.productButtons = [];
      this.periodButtons = [];
      this.revealElements = [];

      this.selectedProduct = null;
      this.selectedPeriod = null;

      this.products = [];
      this.periods = [];
      this.data = null;
    }
  }

  function initializeSection(section) {
    if (
      !section ||
      instances.has(section)
    ) {
      return;
    }

    const instance =
      new DigiClubSavingsCalculator(
        section
      );

    instances.set(
      section,
      instance
    );
  }

  function initializeWithin(root) {
    if (!root) {
      return;
    }

    if (
      root.matches?.(
        SECTION_SELECTOR
      )
    ) {
      initializeSection(root);
    }

    root
      .querySelectorAll?.(
        SECTION_SELECTOR
      )
      .forEach(initializeSection);
  }

  function unloadWithin(root) {
    if (!root) {
      return;
    }

    const sections = [];

    if (
      root.matches?.(
        SECTION_SELECTOR
      )
    ) {
      sections.push(root);
    }

    root
      .querySelectorAll?.(
        SECTION_SELECTOR
      )
      .forEach((section) => {
        sections.push(section);
      });

    sections.forEach((section) => {
      const instance =
        instances.get(section);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(section);
    });
  }

  function handleBlockSelect(event) {
    const blockId =
      event.detail?.blockId;

    if (!blockId) {
      return;
    }

    let section =
      event.target?.closest?.(
        SECTION_SELECTOR
      );

    if (!section) {
      const blockElement =
        document.querySelector(
          `${SECTION_SELECTOR} ` +
          `[data-product-block-id="${CSS.escape(
            String(blockId)
          )}"], ` +
          `${SECTION_SELECTOR} ` +
          `[data-period-block-id="${CSS.escape(
            String(blockId)
          )}"]`
        );

      section =
        blockElement?.closest?.(
          SECTION_SELECTOR
        );
    }

    if (!section) {
      return;
    }

    const instance =
      instances.get(section);

    instance?.selectBlock(
      blockId
    );
  }

  function onReady() {
    initializeWithin(document);
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      onReady,
      {
        once: true
      }
    );
  } else {
    onReady();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initializeWithin(
        event.target
      );
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      unloadWithin(
        event.target
      );
    }
  );

  document.addEventListener(
    "shopify:block:select",
    handleBlockSelect
  );
})();